"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var popper_js_1 = __importDefault(require("popper.js"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined,
        };
        _this.popupRef = react_1.default.createRef();
        _this.updatePosition = function (data) {
            _this.setState({
                data: data,
            });
        };
        return _this;
    }
    Overlay.prototype.componentDidMount = function () {
        var _this = this;
        requestAnimationFrame(function () {
            // tslint:disable-next-line:no-commented-code
            var container = _this.props.containerRef.current;
            // This is for datepickers
            if (container.input) {
                container = container.input;
            }
            var popper = _this.popupRef.current;
            if (popper) {
                _this._poperInstance = new popper_js_1.default(container, popper, {
                    placement: "bottom-start",
                    onCreate: _this.updatePosition,
                    onUpdate: _this.updatePosition,
                    positionFixed: true,
                    modifiers: {
                        applyStyle: { enabled: false },
                        offset: { offset: "-1", enabled: true },
                    },
                });
                _this._poperInstance.scheduleUpdate();
            }
        });
    };
    Overlay.prototype.componentWillUnmount = function () {
        if (this._poperInstance) {
            this._poperInstance.destroy();
        }
    };
    Overlay.prototype.getPopperStyle = function (data) {
        if (!data) {
            return {};
        }
        // Calculate TOP position
        var topMargin = 10;
        if (data.offsets.reference.top > data.offsets.popper.top) {
            topMargin *= -1;
        }
        return __assign(__assign({}, data.styles), { top: topMargin, zIndex: 2000 });
    };
    Overlay.prototype.render = function () {
        var _a = this.props, classNames = _a.classNames, children = _a.children, containerRef = _a.containerRef, portal = _a.portal, selectedDay = _a.selectedDay, hideTodayButton = _a.hideTodayButton, other = __rest(_a, ["classNames", "children", "containerRef", "portal", "selectedDay", "hideTodayButton"]);
        var popper = (react_1.default.createElement("div", __assign({ ref: this.popupRef, style: this.getPopperStyle(this.state.data), className: classNames.overlay + " " + (hideTodayButton ? "DayPicker-HideTodayButton" : "") }, other), children));
        return portal ? react_dom_1.createPortal(popper, portal) : popper;
    };
    return Overlay;
}(react_1.default.Component));
exports.default = Overlay;
//# sourceMappingURL=Overlay.js.map